var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from "react";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import SettingsImageCard from "./SettingsImageCard";
function ImageGallery(_a) {
    var images = _a.images, onUpload = _a.onUpload, onDelete = _a.onDelete, _b = _a.pageSize, pageSize = _b === void 0 ? 12 : _b;
    var _c = useState(pageSize), visible = _c[0], setVisible = _c[1];
    var inputRef = useRef(null);
    var storageUrl = process.env.REACT_APP_STORAGE_URL;
    var shown = images.slice(0, visible);
    function handleFile(e) {
        var _a;
        var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file && onUpload)
            onUpload(file);
        if (inputRef.current)
            inputRef.current.value = "";
    }
    return (_jsxs("div", __assign({ className: "settings-gallery" }, { children: [_jsxs("div", __assign({ className: "settings-image-grid" }, { children: [shown.map(function (img) { return (_jsx(SettingsImageCard, { src: img.path ? "".concat(storageUrl, "/").concat(img.path) : undefined, orientation: img.orientation, onDelete: onDelete ? function () { return onDelete(img.id); } : undefined }, img.id)); }), shown.length === 0 && _jsx("p", __assign({ className: "settings-empty" }, { children: "Nenhuma imagem ainda." }))] })), _jsxs("div", __assign({ className: "settings-gallery-actions" }, { children: [visible < images.length && (_jsx("button", __assign({ type: "button", className: "continue-button button-with-blue-border settings-action-btn", onClick: function () { return setVisible(function (v) { return v + pageSize; }); } }, { children: "Mostrar mais" }))), onUpload && (_jsxs(_Fragment, { children: [_jsxs("button", __assign({ type: "button", className: "continue-button blue-button settings-action-btn", onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, { children: [_jsx(FileUploadOutlinedIcon, { fontSize: "small" }), " Adicionar"] })), _jsx("input", { ref: inputRef, type: "file", accept: "image/*", style: { display: "none" }, onChange: handleFile })] }))] }))] })));
}
export default ImageGallery;
